/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},

  REJECTED_DOCS_APPLICANT_SUCCESS: {
    message: 'Application submitted Successfully',
  },
  REJECTED_DOCS_APPLICANT_ERROR: {
    message: 'Failed to submit application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.rejectedDocuments',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_REJECTED_DOCS_APPLICANT' },
      },
    },
    INITIATE_REJECTED_DOCS_APPLICANT: {
      invoke: {
        id: 'rejectedDocsApplicant',
        src: 'rejectedDocsApplicant',
        onDone: {
          target: 'REJECTED_DOCS_APPLICANT_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REJECTED_DOCS_APPLICANT_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    REJECTED_DOCS_APPLICANT_SUCCESS: {
      // type: 'final',
      on: {
        TRIGGER_REFRESH: {
          target: 'idle',
        },
      },
    },
    REJECTED_DOCS_APPLICANT_ERROR: {
      // type: 'final',
      on: {
        MUTATE: { target: 'INITIATE_REJECTED_DOCS_APPLICANT' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
